import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';

interface Props {
  value?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PrefecturesSelects',
  props: {
    value: {}
  },
  emits: ['selectValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 入力値
const prefecture = ref(computed(() => props.value));
const items = [
  '北海道',
  '岩手県',
  '秋田県',
  '福島県',
  '栃木県',
  '埼玉県',
  '東京都',
  '新潟県',
  '石川県',
  '山梨県',
  '岐阜県',
  '愛知県',
  '滋賀県',
  '大阪府',
  '奈良県',
  '鳥取県',
  '岡山県',
  '山口県',
  '香川県',
  '高知県',
  '佐賀県',
  '熊本県',
  '宮崎県',
  '沖縄県',
  '青森県',
  '宮城県',
  '山形県',
  '茨城県',
  '群馬県',
  '千葉県',
  '神奈川',
  '富山県',
  '福井県',
  '長野県',
  '静岡県',
  '三重県',
  '京都府',
  '兵庫県',
  '和歌山',
  '島根県',
  '広島県',
  '徳島県',
  '愛媛県',
  '福岡県',
  '長崎県',
  '大分県',
  '鹿児島',
];

/**
 * プルダウン選択値を返却
 * @param event プルダウン選択値
 */
const selectValue = (event: string) => {
  emit('selectValue', event);
};

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: prefecture.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((prefecture).value = $event)),
      selectValue
    ],
    outlined: "",
    options: items,
    dense: "",
    "options-dense": "",
    rules: [(val) => !!val || _ctx.$t('validation.required')],
    class: "input-area pref-area"
  }, null, 8, ["modelValue", "rules"]))
}
}

})